import { Component, DestroyRef, EventEmitter, Input, Output, effect, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '@services/settings/app-settings.service';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
import { EntitySharingService } from '@services/core/sharing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { normalizeTerm, filterByTerm, matchesEntity } from './header-entity.utils';
declare var slideToggle: any;

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ["./header.component.css"],
	providers: [EntitySharingService],
	changeDetection: ChangeDetectionStrategy.Default,
	standalone: true,
})
export class HeaderComponent implements OnInit{
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();

	protected logo = ""
	protected profilePhotoURL
	protected userData
	public entities = []
	public entitiesTemp = []
	public appSettings = inject(AppSettings)
	private userService = inject(UserService)
	private authMicrosoft = inject(MicrosoftAuthService)
  private entitySharingService = inject(EntitySharingService)
  private destroyRef = inject(DestroyRef)

	toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
	}

	constructor(){
		effect(()=> {
			this.userData = this.userService.userData()
			this.profilePhotoURL = this.userService.userPhoto()
			
		})
		effect(() => {
			this.entities = this.userService.sharingEntities()
			this.entitiesTemp = this.entities
		})
	}

	ngOnInit(): void {
		
	}
	
	logout() {
		this.authMicrosoft.clearSession()
		this.authMicrosoft.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
			next: (res) => {
				let a = document.createElement('a')
				a.href = res.url
				a.click()
			},
			error: (err) => console.error('Error al cerrar sesión:', err)
		})
	}

	changeEntity(entity){
		this.userService.sharingEntity.set(entity)
		this.entitySharingService.setEntity(entity).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
			next: () => {},
			error: (err) => console.error('Error al cambiar entidad:', err)
		})
	}

	filterEntities(event: any) {
		const term = normalizeTerm(event)
		this.entities = filterByTerm(this.entitiesTemp, term)
	}

	private matchesEntity(entity: any, term: string): boolean {
		return matchesEntity(entity, term)
	}
}
